export default __webpack_public_path__ + "static/media/startup-chile.d431a23b.svg";